import Axios from '../config/axios';
import AppNotification from '../models/AppNotification';
import MasterData from '../models/masterData';
import ApiResponse from '../utils/ApiResponse';

class AuthService extends Axios {
  constructor() {
    super();
  }

  async sendOtp(data: { email: string }): Promise<ApiResponse> {
    const response = await this.post<JSON>(`/auth/login`, data);
    return new ApiResponse(response);
  }

  async verifyOtp(data: {
    email: string;
    code: string;
    token: string;
  }): Promise<ApiResponse> {
    const response = await this.post<JSON>(`/auth/verify`, data);
    return new ApiResponse(response);
  }

  async getNotifications(): Promise<{ records: AppNotification[]; unseenCount: number }> {
    let records: AppNotification[] = [];
    let unseenCount = 0;
    try {
      const response = await this.post<JSON>(`/notification/get`, {});
      const apiResponse = new ApiResponse(response);
      const data = apiResponse.getData();
      records = (
        Array.isArray(data['records']) ? data['records'] : []
      ).map(notification => AppNotification.fromJson(notification));
      unseenCount = typeof data['unseenCount'] === 'number' ? data['unseenCount'] : 0;

      console.error('from notification response', records, data);
    } catch (e) {
      console.error('from notification', e);
    }
    return { records, unseenCount };
  }

  async markNotificationsSeen(notificationIds: number[]): Promise<void> {
    try {
      await this.post<JSON>(`/notification/mark-seen`, { notificationIds });
    } catch (e) {
      console.error('from markNotificationsSeen', e);
    }
  }

  async getMasterData(): Promise<MasterData> {
    const response = await this.post<JSON>(`/master/get`, {});
    const apiResponse = new ApiResponse(response);
    const masterData = MasterData.fromJson(apiResponse.getData());
    return masterData;
  }
}

export default AuthService;
